exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-like-simulator{\n  padding: 10px 30px 10px 30px;\n  border-radius: 4px;\n  border: 1px solid black;\n  text-align: center;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.third-col {\n  float:left;\n  width: 25%;\n  margin-top: 20px;\n}\n\n.third-col p{\n  margin:0;\n  padding:0;\n}\n\n.simulator-header-data {\n  font-family: CircularStd;\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n  opacity: 0.6;\n}\n\n.simulator-header{\n  border-bottom: 1px solid rgba(51,51,51,0.1);\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding-bottom: 25px;\n}\n", ""]);

// exports
